import { Body, Checkbox, FlexBox, FormControl } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';

import { getCandidateDisplayName, getCandidateId } from './helpers';

const PaymentMethodCandidate = ({ candidate, isSelected, onChange }) => {
	const { t } = useTranslation(['signup']);

	return (
		<FormControl
			label={
				<FlexBox flexDirection="column" gap="xxs">
					<Body bold>{getCandidateDisplayName(candidate, t)}</Body>
				</FlexBox>
			}
			labelPosition="right"
			labelWrap="normal"
		>
			<Checkbox
				aria-label={getCandidateDisplayName(candidate, t)}
				checked={isSelected}
				id={`payment-method-${getCandidateId(candidate)}`}
				onChange={onChange}
			/>
		</FormControl>
	);
};

export default PaymentMethodCandidate;
